import Button from '@mui/material/Button'
import styled, { css } from 'styled-components'

import { COLORS, SPACING, TYPOGRAPHY, FONTS } from '../../utils'

export interface ButtonStyle {
  marginTop?: string
  marginBottom?: string
  marginLeft?: string
  marginRight?: string
  backgroundColor?: string
  textColor?: string
  borderColor?: string
  width?: string
  hide?: boolean
  variantButton?: 'text' | 'outlined' | 'default'
  boxShadow?: string
  height?: string
}

export const ButtonCustom = styled(Button) <ButtonStyle>`
  margin: ${SPACING.spacing20};
  font-size: ${TYPOGRAPHY.bodySize16};
  font-family: Arial;
  font-weight: ${FONTS.bold};
  width: ${({ width }) => width || 'auto'};
  visibility: ${({ hide }) => hide && 'hidden'};
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  color: ${({ textColor }) => textColor || COLORS.black};
  padding: 5px 10px;
  height: ${({ height }) => height || 'auto'};
  :hover {
    opacity: 0.6;
  }

  ${({ variantButton, backgroundColor, borderColor, boxShadow }) =>
    variantButton === 'default'
      ? css`
          background: ${backgroundColor ? backgroundColor : COLORS.primary};
          box-shadow: ${boxShadow
          ? boxShadow
          : '0px 2px 4px rgba(50, 15, 0, 0.25)'};
          border: 0.1rem solid ${borderColor ? borderColor : COLORS.primary};
          :hover {
            background-color: ${backgroundColor
          ? backgroundColor
          : COLORS.primary};
          }
        `
      : variantButton === 'outlined'
        ? css`
          background-color: ${COLORS.white};
          border: 0.1rem solid ${borderColor ? borderColor : COLORS.black};
          box-shadow: none;
        `
        : css`
          background-color: ${COLORS.white};
          border: none;
          box-shadow: none;
        `}
`
